'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'bath';
var width = 512;
var height = 512;
var aliases = [128705,"bathtub"];
var unicode = 'f2cd';
var svgPathData = 'M48 53.3c0-20.6 16.7-37.3 37.3-37.3 9.9 0 19.4 3.9 26.3 10.9l32.1 32.1c-9.9 12.3-15.7 27.9-15.7 44.9 0 23.1 10.9 43.7 27.8 56.9l-1.5 1.5c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l104-104c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-1.5 1.5c-13.2-16.9-33.7-27.8-56.9-27.8-17 0-32.6 5.9-44.9 15.7L122.9 15.6C112.9 5.6 99.4 0 85.3 0 55.8 0 32 23.8 32 53.3L32 272 8 272c-4.4 0-8 3.6-8 8s3.6 8 8 8l24 0 0 80c0 38.1 19 71.7 48 91.9L80 504c0 4.4 3.6 8 8 8s8-3.6 8-8l0-34.8c14.5 6.9 30.8 10.8 48 10.8l224 0c17.2 0 33.5-3.9 48-10.8l0 34.8c0 4.4 3.6 8 8 8s8-3.6 8-8l0-44.1c29-20.2 48-53.9 48-91.9l0-80 24 0c4.4 0 8-3.6 8-8s-3.6-8-8-8L48 272 48 53.3zm197.4 18l-78.2 78.2c-14.1-10.2-23.3-26.7-23.3-45.4 0-30.9 25.1-56 56-56 18.7 0 35.3 9.2 45.4 23.3zM48 288l416 0 0 80c0 53-43 96-96 96l-224 0c-53 0-96-43-96-96l0-80z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBath = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;